<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong># Boleta: {{serviceTicket.Number}}</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body>
						<b-row class="mb-4">
							<b-col md="4" lg="4">
								<h6><span class="text-info">Número de Boleta: </span> {{serviceTicket.Number}}</h6>
							</b-col>

							<b-col md="4" lg="4">
								<h6><span class="text-info">Entrada: </span> {{serviceTicket.CheckIn|dateFormatFull}}
								</h6>
							</b-col>

							<b-col md="4" lg="4">
								<h6><span class="text-info">Salida: </span> {{serviceTicket.CheckOut|dateFormatFull}}
								</h6>
							</b-col>

							<b-col md="4" lg="4">
								<h6><span class="text-info">Tiempo Total: </span> {{serviceTicket.TotalTime}}</h6>
							</b-col>

							<b-col v-if="serviceTicket.System" md="4" lg="4">
								<h6><span class="text-info">Sistema: </span> {{serviceTicket.System.Name}}</h6>
							</b-col>

							<b-col v-if="serviceTicket.Technical" md="4" lg="4">
								<h6><span class="text-info">Técnico: </span> {{serviceTicket.Technical.name}}</h6>
								<h6><span class="text-info">Categoría del Técnico: </span>
									{{serviceTicket.TechnicalCategory}}</h6>
								<!--<b-row v-if="serviceTicket.Technical.photo">
									<b-col md="6" lg="6">
										<b-img :src="serviceTicket.Technical.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>-->
							</b-col>

							<b-col v-if="serviceTicket.Technical2" md="4" lg="4">
								<h6><span class="text-info">Técnico #2: </span> {{serviceTicket.Technical2.name}}</h6>
								<h6><span class="text-info">Categoría del Técnico: </span>
									{{serviceTicket.TechnicalCategory2}}</h6>
								<!--<b-row v-if="serviceTicket.Technical.photo">
									<b-col md="6" lg="6">
										<b-img :src="serviceTicket.Technical.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>-->
							</b-col>

							<b-col v-if="serviceTicket.Technical3" md="4" lg="4">
								<h6><span class="text-info">Técnico #3: </span> {{serviceTicket.Technical3.name}}</h6>
								<!--<b-row v-if="serviceTicket.Technical.photo">
									<b-col md="6" lg="6">
										<b-img :src="serviceTicket.Technical.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>-->
							</b-col>

							<b-col v-if="serviceTicket.Technical4" md="4" lg="4">
								<h6><span class="text-info">Técnico #4: </span> {{serviceTicket.Technical4.name}}</h6>
								<!--<b-row v-if="serviceTicket.Technical.photo">
									<b-col md="6" lg="6">
										<b-img :src="serviceTicket.Technical.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>-->
							</b-col>

							<b-col v-if="serviceTicket.Technical5" md="4" lg="4">
								<h6><span class="text-info">Técnico #5: </span> {{serviceTicket.Technical5.name}}</h6>
								<!--<b-row v-if="serviceTicket.Technical.photo">
									<b-col md="6" lg="6">
										<b-img :src="serviceTicket.Technical.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>-->
							</b-col>

							<b-col md="4" lg="4">
								<h6><span class="text-info">Cantidad de Técnicos: </span> {{serviceTicket.TechnicalQty}}
								</h6>
							</b-col>

							<b-col md="12" lg="12" class="mt-3">
								<div class="text-justify">
									<strong class="text-info">Descripción:</strong>
									<br/>
									<strong>{{serviceTicket.Description}}</strong>
								</div>
							</b-col>

							<b-col md="12" lg="12" class="mt-3">
								<div class="text-justify">
									<strong class="text-info">Trabajos Realizados:</strong>
									<br/>
									<strong>{{serviceTicket.TasksPerformed}}</strong>
								</div>
							</b-col>
						</b-row>

						<b-row class="mb-4">
							<h5 class="border-bottom w-100 border-info pb-1">Materiales - Repuestos - MO -
								Adicionales</h5>

							<b-col md="12" lg="12" class="table-responsive">
								<b-table :items="products"
										 :fields="tableFields"
										 :busy="productLoader"
										 show-empty
										 striped
										 empty-filtered-text="No hay registros disponibles"
										 empty-text="No hay registros disponibles"
										 head-variant="light">

									<template v-slot:table-busy>
										<div class="text-center text-info my-2">
											<b-spinner class="align-middle"></b-spinner>
										</div>
									</template>
								</b-table>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import {mapState} from "vuex";

	export default {
		name: "ServiceTicketDetail",
		components: {
			GoBackComponent,
			AccountDetailComponent
		},
		data: function () {
			return {
				loading: false,
				productLoader: false,
				serviceTicket: {},
				products: [],
				tableFields: {
					ProductNumber: {
						label: 'Id del Producto (Articulo)'
					},
					Article: {
						label: 'Artículo'
					},
					Qty: {
						label: 'Cantidad'
					},
					Processing: {
						label: 'Tratamiento'
					},
					Series: {
						label: 'Serie'
					}
				}
			}
		},
		mounted() {
			if (this.accountSelected !== '') {
				this.loading = true;
				const serviceTicketId = this.$route.params.id;

				this.$store.dispatch('getServiceTicketDetail', serviceTicketId)
					.then((serviceTicket) => {
						this.serviceTicket = serviceTicket;
					})
					.finally(() => {
						this.loading = false;
					});

				this.getProducts(serviceTicketId);
			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			getProducts(serviceTicketId) {
				this.productLoader = true;
				this.$store.dispatch('getServiceTicketProducts', serviceTicketId)
					.then((products) => {
						console.log(products);
						this.products = products;
					})
					.finally(() => {
						this.productLoader = false;
					})
			}
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected
			})
		}
	}
</script>

<style scoped>

</style>
